var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1427 13.0006H12.6055V18.9229H15.1427V13.0006Z",
    fill: "#6D57DF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9574 13.0006H17.4202V18.9229H19.9574V13.0006Z",
    fill: "#6D57DF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3292 13.0006H7.79199V18.9229H10.3292V13.0006Z",
    fill: "#6D57DF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2675 20.7134H5.41797V23.1214H22.2675V20.7134Z",
    fill: "#6D57DF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8418 5.38684L5.38477 9.61658V11.3124H22.2989V9.61658L13.8418 5.38684Z",
    fill: "#6D57DF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.383de7ba85212f8f21530a8d66bbf68d.svg";
export { ForwardRef as ReactComponent };